import * as t from 'io-ts';

export enum InputNames {
  addressLine1 = 'addressLine1',
  addressLine2 = 'addressLine2',
  postalCode = 'postalCode',
}

export const FormDataV = t.strict(
  {
    [InputNames.addressLine1]: t.string,
    [InputNames.addressLine2]: t.string,
    [InputNames.postalCode]: t.string,
  },
  'FormDataV',
);

export interface FormData extends t.TypeOf<typeof FormDataV> {}
